import produce from "immer"
import { remove } from "ramda"
import type { Project } from "../projects/projects.types"
import {
  COMPARISON_CLEAR,
  COMPARISON_FETCH,
  COMPARISON_LOAD,
  COMPARISON_LOAD_EMPTY,
  COMPARISON_REMOVE_MAP,
  COMPARISON_SAVE,
  COMPARISON_SET_PROJECTS,
  COMPARISON_UPDATE
} from "./comparison.actions"
import type { Comparison, ComparisonActions, IComparisonState } from "./comparison.types"

export const comparisonsInitialState: IComparisonState = {
  isDirty: false
}

export function comparisonReducer(
  currentState: IComparisonState | undefined,
  action: ComparisonActions
): IComparisonState {
  const state = currentState ?? comparisonsInitialState
  switch (action.type) {
    case COMPARISON_LOAD_EMPTY:
      return setDirtyFlag(setComparison(state, action.payload as Comparison))
    case COMPARISON_REMOVE_MAP:
      return setDirtyFlag(removeProject(state, action.payload as number))
    case COMPARISON_SET_PROJECTS:
      return setDirtyFlag(setProjects(state, action.payload as Project[]))
    case COMPARISON_LOAD:
      return setComparison(state, action.payload as Comparison)
    case COMPARISON_CLEAR:
      return setComparison(state, undefined)
    case COMPARISON_SAVE:
      return clearDirtyFlag(state)
    case COMPARISON_UPDATE:
      return clearDirtyFlag(state)
    case COMPARISON_FETCH:
      return clearDirtyFlag(state)
    default:
      return state
  }
}

function clearDirtyFlag(currentState: IComparisonState): IComparisonState {
  return produce(currentState, (draftState: IComparisonState) => {
    draftState.isDirty = false
  })
}

function setDirtyFlag(currentState: IComparisonState): IComparisonState {
  return produce(currentState, (draftState: IComparisonState) => {
    draftState.isDirty = true
  })
}

function setComparison(currentState: IComparisonState, comparison?: Comparison): IComparisonState {
  return produce(currentState, (draftState: IComparisonState) => {
    draftState.comparison = comparison
  })
}

function removeProject(currentState: IComparisonState, index: number): IComparisonState {
  return produce(currentState, (draftState: IComparisonState) => {
    if (!draftState.comparison) return

    draftState.comparison.projects = remove(index, 1, draftState.comparison.projects)
  })
}

function setProjects(currentState: IComparisonState, projects: Project[]): IComparisonState {
  return produce(currentState, (draftState: IComparisonState) => {
    if (!draftState.comparison) return

    draftState.comparison.projects = projects
  })
}
